<template>
  <b-loading
    is-full-page
    :active="isActive"
  >
    <div v-if="isDefault">
      <div class="loading-icon" />
      <p
        v-if="loadingText"
        class="loading-text"
      >
        {{ loadingText }}
      </p>
    </div>
    <div v-else-if="isImg">
      <img
        class="loading-icon"
        :src="loadingSpinner.asset"
      >
      <p
        v-if="loadingText"
        class="loading-text"
      >
        {{ loadingText }}
      </p>
    </div>
    <div
      v-else
      class="loading-lottie"
    >
      <LottieAnimation
        class="lottie"
        :path="loadingSpinner.asset"
        :height="height"
        :width="width"
      />
      <p
        v-if="loadingText"
        class="loading-text"
      >
        {{ loadingText }}
      </p>
    </div>
  </b-loading>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  PropSync,
  Vue,
} from 'vue-property-decorator'
import TenantEnum from '@/services/enums/TenantEnum'

enum LoadingAssetType {
  default,
  lottie,
  img,
}

@Component({
  components: {
    LottieAnimation: () => import('./LottieAnimation.vue'),
  },
})
export default class Loading extends Vue {
  @PropSync('active', { type: Boolean }) private isActive!: boolean

  @Prop({ default: '' }) private loadingText!: string

  height = 300

  width = 300

  get isDefault() {
    return this.loadingSpinner.type === LoadingAssetType.default
  }

  get isImg() {
    return this.loadingSpinner.type === LoadingAssetType.img
  }

  get loadingSpinner() {
    switch (this.$services.tenant) {
      case TenantEnum.KeeyPartners:
        this.height = 500
        this.width = 500
        return {
          type: LoadingAssetType.lottie,
          asset: Math.random() >= 0.5 ? '/assets/img/keeypartners/lottie/scratch-loading.json' : '/assets/img/keeypartners/lottie/patch-loading.json',
        }
      case TenantEnum.Hagerty:
        return {
          type: LoadingAssetType.img,
          asset: '/assets/img/hagerty/animated-svg/hagerty-loading.svg',
        }
      default:
        return {
          type: LoadingAssetType.default,
        }
    }
  }
}
</script>
